import { z } from 'zod';
import { itemSchema } from './item/item-dto';

/**
 * Roadmap items metadata
 * Includes inaccessible item IDs (items that exist in dataset but user can't access).
 */
export const roadmapItemsMetadataSchema = z.object({
  inaccessibleItemIds: z.array(z.number().int()),
});

export type RoadmapItemsMetadataDTO = z.infer<typeof roadmapItemsMetadataSchema>;

/**
 * Roadmap items response DTO
 * Response from GET /api/v1/roadmap/:roadmapId/items endpoint.
 * Includes all items in the roadmap's dataset.
 * Tree hierarchy is calculated client-side from item.parentId.
 */
export const roadmapItemsResponseSchema = z.object({
  items: z.array(itemSchema),
  metadata: roadmapItemsMetadataSchema,
});

export type RoadmapItemsResponseDTO = z.infer<typeof roadmapItemsResponseSchema>;
